<template>
  <div>
    <b-tabs pills card>
      <b-tab :title="$t('Main')">
        <b-col>
          <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
              <b-form-invalid-feedback id="inputFeedback">
                {{ $t('Select accounting period') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Login')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="hotspotService.login" :state="inputLoginState"  aria-describedby="input-live-help input-live-feedback" trim/>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ $t('Enter only english letters, numbers, at least 1 letter') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Password')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="hotspotService.password"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-select :options="listOfChargePolicy" v-model="hotspotService.policy_id"/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="number" v-model="hotspotService.cost_coef"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
            <b-input-group>
              <b-form-input type="text" v-model="hotspotService.charged_in_curr_period" disabled/>
              <b-input-group-append>
                <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-tab>
      <b-tab :title="$t('Additional')">
        <b-col>
          <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderStartDate"
            :isDisabled="isEdit"
            @onDateChanged="(unixDate) => {hotspotService.start_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(hotspotService.start_date ? hotspotService.start_date : new Date()/1000 ).toDate())}"
            />
          </b-form-group>
          <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <flat-picker :key="rerenderExpDate"
            :isDisabled="infinityDate"
            @onDateChanged="(unixDate) => {hotspotService.expire_date = unixDate}"
            @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(hotspotService.expire_date ? hotspotService.expire_date : new Date()/1000 ).toDate())}"
            />
            <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('House')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-input-group>
              <b-form-input type="text" disabled breakpoint="lg" v-model="userHouse" :placeholder="$t('Tap to select')"/>
              <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormHouse"/>
              <b-input-group-append>
                <b-button variant="secondary" size="sm" @click="clear">{{ $t('Clear') }}</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Address comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="hotspotService.house_comment"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="hotspotService.comment"/>
          </b-form-group>
        </b-col>
      </b-tab>
    </b-tabs>

    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService" size="lg"/>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="hotspotService.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="houseUser" hide-footer :title="$t('Buildings')" size="xl">
      <FormHouse v-model="hotspotService.house_id" @hideFormHouse="hideFormHouse"></FormHouse>
    </b-modal>

    <b-modal ref="detailChargePolicies" hide-footer size="lg" >
      <FormChargePolicies v-if="currentChargePolicy" @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormHouse from '@/pages/users/usersAndGroups/detail/contacts/formHouse.vue'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormCharged from './formCharged'
export default {
  components: {
    FormAccountinfPeriod,
    FormHouse,
    FormChargePolicies,
    FormCharged
  },
  props: {
    listOfChargePolicy: null,
    tariffLinkId: 0,
    accountingPeriodId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      rerenderStartDate: 0,
      rerenderExpDate: 0,
      isShowHouseUser: false,
      infinityDate: true,
      hotspotServiceEdit: null,
      currentChargePolicy: null,
      hotspotService: {
        'house_comment': '',
        'charged_in_curr_period': '',
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tplink_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().unix(),
        'expire_date': moment(2000000000 * 1000).unix(),
        'policy_id': 1,
        'house_id': 0,
        'comment': '',
        'unabon': 0,
        'cost_coef': 100,
        'login': '',
        'password': '',
        'slink_id': 0
      }
    }
  },
  methods: {
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormChargePolicies () {
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        if (this.hotspotService.policy_id === el.policy_id) {
          this.currentChargePolicy = JSON.parse(JSON.stringify(el))
          this.$refs.detailChargePolicies.show()
        }
      }
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormHouse () {
      this.isShowHouseUser = true
      this.$refs.houseUser.show()
    },
    hideFormHouse () {
      this.isShowHouseUser = false
      this.$refs.houseUser.hide()
    },
    clear () {
      this.hotspotService.house_id = 0
    },
    saveServiceLink () {
      if (this.hotspotService.accounting_period_id === 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
      } else if (this.validation()) {
        let tmpHotspotService = JSON.parse(JSON.stringify(this.hotspotService))
        // tmpHotspotService.start_date = Number(Date.parse(tmpHotspotService.start_date)) / 1000
        tmpHotspotService.expire_date = this.infinityDate ? 2000000000 : tmpHotspotService.expire_date
        tmpHotspotService.cost_coef = tmpHotspotService.cost_coef / 100
        tmpHotspotService.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
        if (this.isEdit) {
          tmpHotspotService.slink_id = this.currentService.service_link_id
        } else {
          tmpHotspotService.account_id = this.selectedAccount
          tmpHotspotService.service_id = this.currentService.service_id
          tmpHotspotService.user_id = this.currentUser.user_id
        }
        let response = this.isEdit
          ? this.$store.dispatch('Users/UPDATE_HOTSPOT_SERVICE_LINK', tmpHotspotService)
          : this.$store.dispatch('Users/CREATE_HOTSPOT_SERVICE_LINK', tmpHotspotService)
        response.then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
            this.hideSelectService()
            this.$root.$emit('makeToasts')
          }
        })
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('"Login" is incorrect'), 'Error')
      }
    },
    validation () {
      if (this.hotspotService.login.length === 0) {
        return false
      }
      let strArray = this.hotspotService.login.split('')
      let goodChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@.,-_+'.split('')
      strArray = strArray.filter((value) => {
        return goodChars.includes(value)
      })
      return strArray.join('').length === this.hotspotService.login.length
    }
  },
  mounted () {
    if (this.isEdit) {
      this.$store.dispatch('Users/GET_HOTSPOT_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.hotspotServiceEdit = this.$store.getters['Users/HOTSPOT_SERVICE_LINK']
        this.hotspotService.start_date = this.hotspotServiceEdit.periodicservicelink.start_date
        this.hotspotService.expire_date = this.hotspotServiceEdit.periodicservicelink.expire_date
        this.rerenderStartDate += 1
        this.rerenderExpDate += 1
        this.infinityDate = this.hotspotServiceEdit.periodicservicelink.expire_date === 2000000000
        this.hotspotService.cost_coef = this.hotspotServiceEdit.periodicservicelink.cost_coef * 100
        this.hotspotService.comment = this.hotspotServiceEdit.periodicservicelink.comment
        this.hotspotService.password = this.hotspotServiceEdit.hotspotservicelink.password
        this.hotspotService.login = this.hotspotServiceEdit.hotspotservicelink.login
        this.hotspotService.accounting_period_id = this.hotspotServiceEdit.periodicservicelink.accounting_period_id
        this.hotspotService.house_comment = this.hotspotServiceEdit.periodicservicelink.house_comment
        this.hotspotService.house_id = this.hotspotServiceEdit.periodicservicelink.house_id
        this.hotspotService.policy_id = this.hotspotServiceEdit.periodicservicelink.policy_id
        this.hotspotService.charged_in_curr_period = Number.parseFloat(this.hotspotServiceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
      })
    } else {
      this.hotspotService.policy_id = this.currentService.policy_id
      this.hotspotService.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
    }
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
  },
  computed: {
    selectAccountingPeriod () {
      let selectAccountingPeriod = ''
      if (this.hotspotService.accounting_period_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
          if (el.id === this.hotspotService.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            selectAccountingPeriod = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          }
        }
      }
      return selectAccountingPeriod
    },
    userHouse () {
      let userHouse = ''
      if (this.hotspotService.house_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['ReferenceBooks/BUILDINGS']))) {
          if (el.house_id === this.hotspotService.house_id) {
            if (el.post_code.length > 0) {
              userHouse += el.post_code + ', '
            }
            if (el.country.length > 0) {
              userHouse += el.country + ', '
            }
            if (el.region.length > 0) {
              userHouse += el.region + ', '
            }
            if (el.city.length > 0) {
              userHouse += el.city + ', '
            }
            if (el.street.length > 0) {
              userHouse += el.street + ', '
            }
            if (el.number.length > 0) {
              userHouse += el.number + ', '
            }
            if (el.building.length > 0) {
              userHouse += el.building + ', '
            }
            userHouse += '(' + el.house_id + ')'
            break
          }
        }
      }
      return userHouse
    },
    inputLoginState () {
      return this.validation()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formHotspot.vue